import { render, staticRenderFns } from "./ModuleFormDialog.vue?vue&type=template&id=58e22750&"
import script from "./ModuleFormDialog.vue?vue&type=script&lang=ts&"
export * from "./ModuleFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports